import React, { useState, useEffect } from 'react'
import { IoMdMenu } from "react-icons/io";
import { BrowserRouter as Router, Routes, Route, Link, useLocation  } from 'react-router-dom';
import "./Navbar.css"

const Navbar = () => {
  const [sticky, setSticky] = useState(false)
  const location = useLocation();

  useEffect(() => {
    window.addEventListener("scroll", () => {
      window.scrollY > 50 ? setSticky(true) : setSticky(false);
    })
  }, [])

  const [mobileMenu, setMobileMenu] = useState(false)

  const toggleMenu = () => {
    mobileMenu ? setMobileMenu(false) : setMobileMenu(true)
  }

  const isActive = (path) => location.pathname === path ? 'btn' : '';
  const closeMenu = () => { setMobileMenu(false); }
  
  return (
    <nav className={`container ${sticky ? "dark-nav" : ""}`}>
        {/* <img src={logo} alt="" className='logo'/> */}

        <div className='double-navbar'>
            <ul className={mobileMenu ? "" : "hide-mobile-menu"}>
                <li> <Link to='/'             smooth={true} offset={0}    duration={500} onClick={closeMenu} className={isActive('/')}>Home</Link> </li> 
                <li> <Link to='/pasco'     smooth={true} offset={-260} duration={500} onClick={closeMenu} className={isActive('/pasco')}>EduZolve Pasco</Link></li>
                <li> <Link to='/codingtraining'     smooth={true} offset={-260} duration={500} onClick={closeMenu} className={isActive('/codingtraining')}>Coding Training</Link></li>
                <li> <Link to='/aboutus'      smooth={true} offset={-260} duration={500} onClick={closeMenu} className={isActive('/aboutus')}>About Us</Link></li>
                {/* <li> <Link to='/publication'      smooth={true} offset={-260} duration={500} onClick={closeMenu} className={isActive('/publication')}>Publications</Link> </li> */}
                {/* <li> <Link to='/contact'      smooth={true} offset={-260} duration={500} onClick={closeMenu} className={isActive('/contact')}>Contact us</Link> </li> */}
            
            
            </ul>
       </div>
       {/* <img src={menu_icon} alt="" className='menu-icon' onClick={toggleMenu}/>  */}
       <IoMdMenu size={30} color="white" className='menu-icon' onClick={toggleMenu}/>

    </nav>
  )
}

export default Navbar
